import { Component, OnInit, Input } from "@angular/core";
import { ConditionSelecterModalComponent } from "./condition-selecter-modal.component";
import { CommonService } from "../service/common.service";
import { UsersService } from "../service/users.service";
import { YoyakuMasterService } from "../service/ymaster.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "yconditions-group-s-app",
  templateUrl: "./yconditions-group-s.component.html",
  styleUrls: ["yconditions-group-s.component.css"],
})
export class YConditionsGroupSComponent implements OnInit {
  title: string = "予約条件（小）";
  isLoaded: boolean = false;
  selected: boolean = false;
  all_datalist: any = [];
  datalist: any = [];
  all_count: number;
  conditionlist: any = [];
  tempSelectedRow: any;
  display_per_page: number = 2; /* 最大表示件数 */
  content_list_info: any = {
    name_name: "タイトル",
    name_description: "説明文",
    name_support: "タイトルを入力してください",
    description_support: "説明文を入力してください",
    data: {},
    conditionslist: [],
  };
  selectedCondition: any = [];
  selectedCompany: any = [];
  selectedMaster: any = [];
  selected_s_condition_id: string = null;
  selectedContentName: string = "";
  selectedMasterIds: string = "";
  inputMode: number = null;
  numValue: string = null;
  error:boolean = false;
  operatorlist: any = [
    { id: 0, name: "等しい", operator: "=", enabled: true },
    { id: 1, name: "以上", operator: "<=", enabled: true },
    { id: 2, name: "以下", operator: ">=", enabled: true },
    { id: 3, name: "含む", operator: "IN", enabled: true },
  ];
  dupcheckLists: boolean = false;

  constructor(
    private commonService: CommonService,
    private ymasterService: YoyakuMasterService,
    private modalService: NgbModal,
    private router: Router,
    public usersService: UsersService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getList();
  }
  clearData(): void {
    this.isLoaded = false;
    this.selected = false;
    this.datalist = [];
  }
  getList(): void {
    this.ymasterService.getConditions().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.conditionlist = res["fuel_results"]["fixed_condition"];
          this.conditionlist.data = res["fuel_results"]["condition_content"];
          // this.all_datalist = res["fuel_results"]["condition_s"];
          this.datalist = res["fuel_results"]["condition_s"];
          this.all_count = res["fuel_results"]["all_count_s"];
          // this.changePage(1);
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
  save(): void {
    this.commonService.modalOpens(
      50001,
      //保存してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.ymasterService
            .saveConditions(this.content_list_info.data)
            .subscribe(
              (res: Response) => {
                if (res["fuel_status"] == "OK") {
                  this.commonService.modalOpens(10001, (modalresult) => {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                    this.clearContent();
                    this.getList();
                  });
                } else if (res["fuel_status"] == "NG") {
                  this.commonService.modalOpens(
                    res["fuel_message"],
                    (modalresult) => {}
                  );
                } else {
                  this.commonService.modalOpens(11003, (modalresult) => {});
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              }
            );
        } else {
          //
        }
      }
    );
  }
  delete(): void {
    this.commonService.modalOpens(
      50002,
      //削除してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.ymasterService
            .deleteConditions(this.content_list_info.data)
            .subscribe(
              (res: Response) => {
                if (res["fuel_status"] == "OK") {
                  this.commonService.modalOpens(10002, (modalresult) => {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                    this.getList();
                  });
                } else if (res["fuel_status"] == "NG") {
                  this.commonService.modalOpens(
                    res["fuel_message"],
                    (modalresult) => {}
                  );
                } else {
                  this.commonService.modalOpens(11003, (modalresult) => {});
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              }
            );
        } else {
        }
      }
    );
  }
  changePage(e) {
    var start = (e - 1) * this.display_per_page;
    this.datalist = this.all_datalist.slice(
      start,
      start + this.display_per_page
    );
  }
  resetOperatorlist(id: string): void {
    this.operatorlist = [
      { id: 0, name: "等しい", operator: "=", enabled: true },
      { id: 1, name: "以上", operator: "<=", enabled: true },
      { id: 2, name: "以下", operator: ">=", enabled: true },
      { id: 3, name: "含む", operator: "IN", enabled: true },
    ];
    if (id == "2") {
      for (let i = 0; this.operatorlist.length > i; i++) {
        if (this.operatorlist[i].id != 0) {
          this.operatorlist[i].enabled = false;
        }
      }
    } else if (id == "12") {
      for (let i = 0; this.operatorlist.length > i; i++) {
        if (this.operatorlist[i].id == 3) {
          this.operatorlist[i].enabled = false;
        }
      }
    } else {
      for (let i = 0; this.operatorlist.length > i; i++) {
        if (this.operatorlist[i].id == 1 || this.operatorlist[i].id == 2) {
          this.operatorlist[i].enabled = false;
        }
      }
    }
  }
  edit(row: any): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.clearContent();
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
          } else {
            return;
          }
        }
      );
    } else {
      this.editSelectRowData(row);
      //画面上部へ移動
      window.scrollTo(0, 0);
    }
  }
  editSelectRowData(row: any): void {
    if (row == undefined) {
      this.selected = true;
      this.content_list_info.data = {
        t_conditions_s_id: null,
        s_yoyaku_conditions_id: null,
        t_event_id: null,
        t_conditions_s_name: null,
        operator: null,
        condition_nm: null,
        table_nm: null,
        parent_table_nm: null,
        parent_table_id: null,
        sort: null,
        update_datetime: null,
        values: [
          {
            conditions_s_value_id: null,
            conditions_s_value: null,
            id: null,
            code: null,
            name: null,
          },
        ],
      };
    } else {
      this.selected = true;
      this.content_list_info.data = JSON.parse(JSON.stringify(row));
      this.tempSelectedRow = JSON.parse(JSON.stringify(row));
    }
    this.selectCondition(this.content_list_info.data.s_yoyaku_conditions_id, 1);
    this.selectEvent(this.content_list_info.data.t_event_id, 1);
    this.selectMaster(this.content_list_info.data.parent_table_id, 1);
    this.selectOperator(this.content_list_info.data.operator);
    this.selectedValue();
    if(this.content_list_info.data.s_yoyaku_conditions_id == 12){
      this.numValue = this.content_list_info.data.values[0].conditions_s_value;
    }
  }
  selectCondition(id, mode): void {
    if (id != null && id != undefined) {
      if (mode == 0) {
        this.content_list_info.data.t_event_id = null;
        this.content_list_info.data.parent_table_id = null;
        this.selected_s_condition_id = null;
        this.content_list_info.data.operator = null;
        this.inputMode = null;
      }
      var tmplist = this.conditionlist.filter((item) => item.id === id);
      var table_nm = tmplist[0].table_nm;
      this.selectedCondition = this.conditionlist.data[table_nm];
      if (id == "1") {
        this.selectedMaster = this.selectedCondition;
      }
      this.resetOperatorlist(id);
    }
  }
  selectEvent(id, mode): void {
    if (id != null && id != undefined) {
      if (mode == 0) {
        this.content_list_info.data.parent_table_id = null;
        this.selected_s_condition_id = null;
        this.content_list_info.data.operator = null;
        this.inputMode = null;
      }
      this.selectedCompany = this.conditionlist.data["t_company"];
      this.selectedCompany = this.selectedCompany.filter(
        (item) => item.content_parent_id === id
      );
    }
  }
  selectMaster(id, mode): void {
    if (id != null && id != undefined) {
      if (mode == 0) {
        this.selected_s_condition_id = null;
        this.content_list_info.data.operator = null;
        this.inputMode = null;
      }
      this.selectedMaster = this.selectedCondition.filter(
        (item) => item.content_parent_id === id
      );
    }
  }
  selectOperator(operator): void {
    if (this.content_list_info.data.s_yoyaku_conditions_id == "2") {
      this.inputMode = null;
    } else if (
      operator == "=" &&
      this.content_list_info.data.s_yoyaku_conditions_id != "12"
    ) {
      this.inputMode = 1;
    } else if (
      operator == "<=" ||
      operator == ">=" ||
      this.content_list_info.data.s_yoyaku_conditions_id == "12"
    ) {
      this.inputMode = 2;
    } else if (
      operator == "IN" &&
      this.content_list_info.data.s_yoyaku_conditions_id != "2"
    ) {
      this.inputMode = 3;
    } else {
      this.inputMode = null;
    }
  }
  disabledEventSelecter(): boolean {
    if (
      this.content_list_info.data.s_yoyaku_conditions_id != null &&
      this.content_list_info.data.s_yoyaku_conditions_id != "1" &&
      this.content_list_info.data.s_yoyaku_conditions_id != "12"
    ) {
      return false;
    } else {
      return true;
    }
  }
  disableCompanySelecter(): boolean {
    if (this.disabledEventSelecter()) {
      return true;
    } else if (this.content_list_info.data.t_event_id == null) {
      return true;
    } else {
      return false;
    }
  }
  disabledOperatorSelecter(): boolean {
    if (
      this.content_list_info.data.s_yoyaku_conditions_id == "1" ||
      this.content_list_info.data.s_yoyaku_conditions_id == "12"
    ) {
      return false;
    } else if (this.content_list_info.data.parent_table_id == null) {
      return true;
    } else {
      return false;
    }
  }
  disabledContentSelecter(): boolean {
    if (this.content_list_info.data.s_yoyaku_conditions_id == "12") {
      return true;
    } else if (this.content_list_info.data.s_yoyaku_conditions_id == "1") {
      return false;
    } else if (this.content_list_info.data.parent_table_id == null) {
      return true;
    }
  }
  selectedValue(): void {
    if (this.content_list_info.data.values.length == 1) {
      this.selected_s_condition_id = this.content_list_info.data.values[0].conditions_s_value;
    } else if (this.content_list_info.data.values.length > 1) {
      var ids = [];
      var names = [];
      for (let i = 0; this.content_list_info.data.values.length > i; i++) {
        ids[i] = this.content_list_info.data.values[i]["conditions_s_value"];
        names[i] =
          this.content_list_info.data.values[i]["code"] +
          "：" +
          this.content_list_info.data.values[i]["name"];
      }
      this.selectedMasterIds = ids.join(",");
      this.selectedContentName = names.join(", ");
    }
  }
  conditionSelect(id): void {
    var selectContent = this.selectedMaster.filter(
      (item) => item.content_id === id
    );
    this.changeValues(selectContent);
  }
  checkList(): boolean {
    if (this.content_list_info.data.s_yoyaku_conditions_id == null) {
      return true;
    }
    if (this.content_list_info.data.s_yoyaku_conditions_id == 12) {
      if (this.numValue == null) {
        return true;
      } else {
        if (this.numcheck()) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (
        (this.selected_s_condition_id == null ||
          this.selected_s_condition_id == "") &&
        this.content_list_info.data.operator == "="
      ) {
        return true;
      }
    }
  }
  clearContent(): void {
    this.content_list_info.data = {
      t_conditions_s_id: null,
      s_yoyaku_conditions_id: null,
      t_event_id: null,
      t_conditions_s_name: null,
      operator: null,
      condition_nm: null,
      table_nm: null,
      parent_table_nm: null,
      parent_table_id: null,
      sort: null,
      update_datetime: null,
      values: [
        {
          conditions_s_value_id: null,
          conditions_s_value: null,
          id: null,
          code: null,
          name: null,
        },
      ],
    };
    this.selectOperator(null);
    this.selectedCondition = [];
    this.selectedCompany = [];
    this.selectedMaster = [];
  }
  clearValues(): void {
    this.content_list_info.data.values = [
      {
        conditions_s_value_id: null,
        conditions_s_value: null,
        id: null,
        code: null,
        name: null,
      },
    ];
    this.selectedContentName = null;
    this.selectedMasterIds = null;
  }
  createContentValues(index: number): void {
    this.content_list_info.data.values[index] = {
      conditions_s_value_id: null,
      conditions_s_value: null,
      id: null,
      code: null,
      name: null,
    };
  }
  changeValues(list: any): void {
    this.clearValues();
    for (let i = 0; list.length > i; i++) {
      this.createContentValues(i);
      this.content_list_info.data.values[
        i
      ].conditions_s_value_id = this.content_list_info.data[
        "t_conditions_s_id"
      ];
      this.content_list_info.data.values[i].conditions_s_value =
        list[i]["content_id"];
      this.content_list_info.data.values[i].id = list[i]["content_id"];
      this.content_list_info.data.values[i].code = list[i]["content_code"];
      this.content_list_info.data.values[i].name = list[i]["content_nm"];
    }
  }
  inputNumValue(): void {
    this.clearValues();
    if (this.numValue != null) {
      if (this.numValue.trim() == "") {
        this.numValue = null;
      } else {
        this.content_list_info.data.values[0].conditions_s_value = this.numValue;
      }
    }
  }
  numcheck():boolean {
    if (this.inputMode == 2){
      if (this.numValue == null){
        return false;
      } else {
        var match = this.numValue.match(/^[0-9]+$/);
        if(!match) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  goContentSelecter(): void {
    this.selectedValue();
    const modalRef = this.modalService.open(
      ConditionSelecterModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.inputContentList = this.selectedMaster;
    modalRef.componentInstance.inputContentIds = this.selectedMasterIds;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
          this.clearValues();
          this.changeValues(result.chackedContent);
          this.selectedValue();
          this.selectedContentName = result.chackedContentNames;
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }
  cancel(): void {
    this.commonService.modalOpens(
      50005,
      //編集中の内容を破棄してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.clearContent();
          this.selected = false;
        } else {
        }
      }
    );
  }
  upRow(row: number, data: any): void {
    let tempdatalist;
    tempdatalist = this.datalist;
    if (row == 0) {
      //最初
    } else {
      //自分のレコード　myRecord
      let myRecord = tempdatalist[row];
      //１つ前のレコード beforeRecord
      let beforeRecord = tempdatalist[row - 1];
      // 旧sortを退避
      myRecord["chk_sort"] = myRecord["sort"];
      beforeRecord["chk_sort"] = beforeRecord["sort"];
      //sortnoを交換する
      let tmpsort = myRecord["sort"];
      myRecord["sort"] = beforeRecord["sort"];
      beforeRecord["sort"] = tmpsort;
      //２レコードをUPDATEする　myRecord,beforeRecord
      this.ymasterService
        .changeOrderCondition([myRecord, beforeRecord])
        .subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              tempdatalist.splice(
                row - 1,
                2,
                tempdatalist[row],
                tempdatalist[row - 1]
              );
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
    }
  }
  downRow(row: number, data: any): void {
    let tempdatalist;
    tempdatalist = this.datalist;
    if (row == tempdatalist.length - 1) {
      //最終
    } else {
      //１つ後ろのレコード afterRecord
      let afterRecord = tempdatalist[row + 1];
      //自分のレコード　myRecord
      let myRecord = tempdatalist[row];
      // 旧sortを退避
      myRecord["chk_sort"] = myRecord["sort"];
      afterRecord["chk_sort"] = afterRecord["sort"];
      //sortnoを交換する
      let tmpsort = myRecord["sort"];
      myRecord["sort"] = afterRecord["sort"];
      afterRecord["sort"] = tmpsort;
      //２レコードをUPDATEする　myRecord,afterRecord
      this.ymasterService
        .changeOrderCondition([myRecord, afterRecord])
        .subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              tempdatalist.splice(
                row,
                2,
                tempdatalist[row + 1],
                tempdatalist[row]
              );
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
    }
  }
  goBack(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.location.back();
          }
        }
      );
    } else {
      this.location.back();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/a2125-yconditions-group-s/yconditions-group-s.component.ts